import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

const requisitar = () => {
  return {
    type: "REQUISITAR_TUTORIAL"
  };
}



const erro = (erro) => {
    return {
      type: "ERRO_TUTORIAL",
      erro
    }
}
const salvar = (tutorial) => {
  return {
    type: "SALVAR_TUTORIAL",
    tutorial
  }
}

const obter = (tutorial) => {
  return {
    type: "OBTER_TUTORIAL",
    tutorial
  }
}
export const obterTutorial = () => {
  return dispatch => {
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/tutoriais?filter[limit]=1`).then((response) => {
      dispatch(obter(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}
export const salvarTutorial = (tutorial) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.patch(`${REQUEST_URL}/tutoriais`,tutorial).then((response) => {
      dispatch(salvar(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/TutorialActions.js